import React from 'react'
import { MdArrowForwardIos } from "react-icons/md";
import common from "../assets/common.jpg"
import fireal from "../assets/fireal.jpg"
import fireala from "../assets/fireala.jpg"
import nitrogen from "../assets/nitrogen.png"
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { AiFillTwitterCircle } from "react-icons/ai";
// import { FaLinkedinIn } from "react-icons/fa";
import { TiSocialLinkedinCircular } from "react-icons/ti";
import { FaArrowRight } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import Footer from './Footer';
import FormPage from './FormPage';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
// import SearchBox from './SearchBox';

const BlogPage3 = () => {
    // const tags = [
    //     "Fire Safety", "Fire Detection", "Safety Equipment", "Fire Alarm", "Fire Protection",
    //     "Smoke Detection", "Gas Fire Suppression", "Emergency Safety", "Industrial Fire Safety"
    // ];

    return (
        <>
            <div className='sticky top-0 z-50 w-full bg-white shadow-md'>
                <Navigation />
            </div>
            <div className="px-4 xl:px-12 py-6 bg-gray-50 min-h-screen">

                <div className="mb-4">
                    <div className="flex flex-wrap items-center gap-2 text-md">
                        <Link to="/" className="text-gray-700 font-medium hover:text-green-700">Home</Link>
                        <MdArrowForwardIos className="text-gray-500 text-xs" />

                        <Link to="/blog1" className="text-gray-700 font-medium hover:text-green-700">Blog</Link>
                        <MdArrowForwardIos className="text-gray-500 text-xs" />

                        <Link to="/blogpage3" className="text-gray-700 font-medium hover:text-green-700">N765</Link>
                        <MdArrowForwardIos className="text-gray-500 text-xs" />

                        <span className="text-gray-500">
                            Fire Alarm System, N765
                        </span>
                    </div>

                    <div className="border-t border-gray-300 mt-3 "></div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mt-12">

                    <div className="w-full lg:col-span-2">
                        {/* MAIN ARTICLE BOX */}

                        <div className="w-full bg-white shadow-md overflow-hidden border-b-4 border-green-600">
                            <div className="px-4 xl:px-12 py-4 xl:py-10">

                                <h2 className="text-2xl md:text-5xl font-medium font-serif text-black leading-tight">
                                    Fire Alarm System, N765
                                </h2>

                                <p className="text-md text-justify text-gray-600 leading-relaxed mt-6">
                                    The Fire Alarm System N765 is a next-generation intelligent fire detection system engineered for high-performance monitoring in modern infrastructures. Known for its superior accuracy, fast response time and robust communication technology, the N765 offers reliable protection for large-scale buildings that require advanced fire detection capabilities. Its addressable architecture allows every connected device to have a specific digital address, making it easy for emergency teams to pinpoint the exact location of an alarm or fault. This precise device-level identification significantly enhances response speed and minimizes downtime during emergencies.
                                </p>

                                <div className="w-full flex justify-center my-8">
                                    <img src={fireala} alt="N765" className="w-full max-w-xs object-cover"
                                    />
                                </div>

                                <p className="text-md text-justify text-gray-600 leading-relaxed">
                                    The N765 supports a wide range of intelligent devices including smoke detectors, heat detectors, multi-sensor detectors, manual call points, input/output modules, and sounder bases. Each device communicates independently with the control panel, allowing the system to continuously analyze environmental changes and respond appropriately. Its advanced algorithm reduces false alarms by interpreting smoke and heat patterns before the system activates an alert. This makes the N765 ideal for sensitive environments such as hotels, hospitals, schools, commercial complexes, and data centers where reliability and stability are essential.
                                    <br /><br />
                                    One of the key strengths of the N765 system is its strong integration capability. It seamlessly connects with third-party equipment such as sprinkler systems, gas suppression systems, HVAC shutdown controllers, and emergency exit systems. Through addressable relay modules, the N765 can perform automated functions during fire events — such as unlocking doors, activating alarms, starting exhaust fans, and switching elevators into fire mode. The control panel features a clear display, intuitive interface, and advanced event logging, allowing building operators to monitor real-time status and handle emergency operations efficiently.
                                </p>

                                <div className="border-t border-gray-400 mt-6"></div>

                                <div className="w-full flex flex-wrap md:flex-nowrap justify-between items-start gap-4 mt-6">
                                    <div className="flex flex-col w-full md:w-auto">
                                        <h1 className="text-xl font-serif text-black mb-4">Connect Us:</h1>
                                        <div className="flex items-center gap-3">
                                            <a
                                                href="https://www.linkedin.com/company/nohmibosai-india/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-12 h-12 flex items-center justify-center rounded-md bg-white text-[#0077B5] hover:bg-[#0077B5] hover:text-white border border-gray-400 hover:border-[#0077B5] transition-colors duration-300">
                                                <FaLinkedin className="w-8 h-8" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* date: 11-12-25 */}
                        {/* <div className="w-full bg-white shadow-md overflow-hidden border-b-4 border-green-600">
                            <div className="relative w-full">
                                <img src={fireala} alt="Home" className="w-full h-auto object-cover" />

                                <div className="flex flex-wrap items-center absolute bottom-0 left-0 gap-2 bg-white max-w-[85%] md:max-w-none">
                                    <Link to='/blogpage3' className="bg-green-500 text-white px-2 xl:px-4 py-2.5 font-medium text-md">
                                        Fire Alarm System, N765
                                    </Link>
                                    // <div className="flex flex-wrap items-center gap-2 px-2 text-sm ">
                                    //     <h2 className="text-gray-600 whitespace-nowrap">December 4, 2025</h2>
                                    //     <span className="text-gray-400">—</span>
                                    //     <Link to="/" className="font-semibold text-gray-800 hover:text-green-800 whitespace-nowrap"> SekureAdmin</Link>
                                    //     <span className="text-gray-400">—</span>
                                    //     <Link to="/" className="font-semibold text-gray-800 hover:text-green-800 whitespace-nowrap mr-4">Comments: 0</Link>
                                    // </div>
                                </div>
                            </div>

                            <div className="px-4 xl:px-14 py-4 xl:py-10 ">
                                <h2 className="text-2xl md:text-5xl font-medium font-serif mt-4 text-black leading-tight">
                                    Fire Alarm System, N765
                                </h2>

                                <p className="text-md text-justify text-gray-600 leading-relaxed mt-8">
                                    The Fire Alarm System N765 is a next-generation intelligent fire detection system engineered for high-performance monitoring in modern infrastructures. Known for its superior accuracy, fast response time and robust communication technology, the N765 offers reliable protection for large-scale buildings that require advanced fire detection capabilities. Its addressable architecture allows every connected device to have a specific digital address, making it easy for emergency teams to pinpoint the exact location of an alarm or fault. This precise device-level identification significantly enhances response speed and minimizes downtime during emergencies.
                                    <br />
                                    The N765 supports a wide range of intelligent devices including smoke detectors, heat detectors, multi-sensor detectors, manual call points, input/output modules, and sounder bases. Each device communicates independently with the control panel, allowing the system to continuously analyze environmental changes and respond appropriately. Its advanced algorithm reduces false alarms by interpreting smoke and heat patterns before the system activates an alert. This makes the N765 ideal for sensitive environments such as hotels, hospitals, schools, commercial complexes, and data centers where reliability and stability are essential.
                                    <br />
                                    One of the key strengths of the N765 system is its strong integration capability. It seamlessly connects with third-party equipment such as sprinkler systems, gas suppression systems, HVAC shutdown controllers, and emergency exit systems. Through addressable relay modules, the N765 can perform automated functions during fire events — such as unlocking doors, activating alarms, starting exhaust fans, and switching elevators into fire mode. The control panel features a clear display, intuitive interface, and advanced event logging, allowing building operators to monitor real-time status and handle emergency operations efficiently.
                                </p>
                                <div className="border-t border-gray-400 mt-8"></div>

                                <div className="w-full flex flex-wrap md:flex-nowrap justify-between items-start gap-4 mt-8">
                                    // <div className="flex flex-col w-full md:w-auto">
                                    //     <h1 className="text-xl text-gray-800 mb-4">Post Tags:</h1>
                                    //     <div className="flex flex-wrap items-center gap-2">
                                    //         <div className="border-2 border-gray-400 hover:border-green-600 bg-white hover:bg-green-600 text-green-600 hover:text-white px-3 py-1">
                                    //             <span className="text-lg lg:text-xl">Smoke Detection</span>
                                    //         </div>
                                    //         <div className="border-2 border-gray-400 hover:border-green-600 bg-white hover:bg-green-600 text-green-600 hover:text-white px-3 py-1">
                                    //             <span className="text-lg lg:text-xl">Fire Alarm</span>
                                    //         </div>
                                    //     </div>
                                    // </div>

                                    <div className="flex flex-col w-full md:w-auto">
                                        <h1 className="text-xl text-black mb-4">Connect Us:</h1>
                                        <div className="flex items-center gap-3">
                                            // <a href="https://www.facebook.com/"
                                            //     target="_blank"
                                            //     rel="noopener noreferrer"
                                            //     className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-[#1877F2] hover:bg-[#1877F2] hover:text-white border border-gray-400 hover:border-[#1877F2] p-2 transition-colors duration-300">
                                            //     <FaFacebook className="w-8 h-8" />
                                            // </a>
                                            // <a href="https://twitter.com/"
                                            //     target="_blank"
                                            //     rel="noopener noreferrer"
                                            //     className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-[#1DA1F2] hover:bg-[#1DA1F2] hover:text-white border border-gray-400 hover:border-[#1DA1F2] p-2 transition-colors duration-300">
                                            //     <AiFillTwitterCircle className="w-8 h-8" />
                                            // </a>
                                            <a href="https://www.linkedin.com/company/nohmibosai-india/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-[#0077B5] hover:bg-[#0077B5] hover:text-white border border-gray-400 hover:border-[#0077B5] transition-colors duration-300">
                                                <TiSocialLinkedinCircular className="w-8 h-8" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="py-4 xl:py-10 flex flex-row justify-between items-center gap-4 flex-nowrap">
                            <div className="flex items-center gap-3">
                                <Link to="/BlogPage2">
                                    <button
                                        className="inline-flex justify-center items-center border-2 border-gray-400 hover:border-green-600 hover:bg-green-600 hover:text-white w-14 h-14 transition duration-300"
                                    >
                                        <FaArrowLeft className="w-5 h-5" />
                                    </button>
                                </Link>
                                <span className="text-md font-semibold">Prev Post</span>
                            </div>

                            <div className="flex items-center gap-3">
                                <span className="text-md font-semibold">Next Post</span>
                                <Link to="/blogPage5">
                                    <button
                                        className="inline-flex justify-center items-center border-2 border-gray-400 hover:border-green-600 hover:bg-green-600 hover:text-white w-14 h-14 transition duration-300"
                                    >
                                        <FaArrowRight className="w-5 h-5" />
                                    </button>
                                </Link>
                            </div>
                        </div>

                        {/* <div><FormPage /></div> */}
                    </div>

                    <div className="space-y-8">

                        {/* <div><SearchBox /></div> */}

                        <div className="sticky top-32 self-start">

                            {/* <div className="bg-white shadow-md px-6 xl:px-10 py-4 xl:py-8 border-b-4 border-green-700">
                                <h2 className="text-2xl font-semibold mb-4">Recent Posts</h2>

                                <Link to="/blogpage">
                                    <div className="flex gap-4 mb-4 mt-8">
                                        <img src={common} alt="Post" className="w-24 h-24 object-cover" />
                                        <div>
                                            <p className="text-sm text-gray-500">Dec 4, 2025</p>
                                            <p className="text-lg font-medium">Common Devices for Addressable Systems</p>
                                        </div>
                                    </div>
                                </Link>

                                <Link to="/blogpage2">
                                    <div className="flex gap-4 mb-4">
                                        <img src={fireal} alt="Post" className="w-24 h-24 object-cover" />
                                        <div>
                                            <p className="text-sm text-gray-500">Dec 4, 2025</p>
                                            <p className="text-lg font-medium">Fire Alarm System, N3060</p>
                                        </div>
                                    </div>
                                </Link>

                                <Link to="/blogpage5">
                                    <div className="flex gap-4">
                                        <img src={nitrogen} alt="Post" className="w-24 h-24 object-cover" />
                                        <div>
                                            <p className="text-sm text-gray-500">Dec 4, 2025</p>
                                            <p className="text-lg font-medium">Nitrogen Gas Suppression System</p>
                                        </div>
                                    </div>
                                </Link>
                            </div> */}

                            {/* <div className="bg-white px-4 xl:px-10 py-4 xl:py-8 shadow-md w-full border-b-4 border-green-600 mt-4">
                                <h1 className="text-xl xl:text-2xl font-semibold mb-4 text-gray-800">Categories</h1>

                                <div className="mt-6 space-y-2">
                                    <div className="group px-3 py-2 xl:py-3 bg-black hover:bg-green-700 transition w-full max-w-md mx-auto">
                                        <Link to="/blogpage">
                                            <div className="flex justify-between items-center">
                                                <h2 className="text-xl font-medium text-white px-3 py-1">
                                                    Common Devices
                                                </h2>
                                                <span className="bg-green-700 group-hover:bg-black text-white rounded-full w-8 h-8 flex items-center justify-center text-sm transition">
                                                    1
                                                </span>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="group px-3 py-2 xl:py-3 bg-black hover:bg-green-700 transition w-full max-w-md mx-auto">
                                        <Link to="/blogpage2">
                                            <div className="flex justify-between items-center">
                                                <h2 className="text-xl font-medium text-white px-3 py-1 rounded">
                                                    N3060
                                                </h2>
                                                <span className="bg-green-700 group-hover:bg-black text-white rounded-full w-8 h-8 flex items-center justify-center text-sm transition">2
                                                </span>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="group px-3 py-2 xl:py-3 bg-black hover:bg-green-700 transition w-full max-w-md mx-auto">
                                        <Link to="/blogpage3">
                                            <div className="flex justify-between items-center">
                                                <h2 className="text-xl font-medium text-white px-3 py-1 rounded">
                                                    N765
                                                </h2>
                                                <span className="bg-green-700 group-hover:bg-black text-white rounded-full w-8 h-8 flex items-center justify-center text-sm transition">3
                                                </span>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="group px-3 py-2 xl:py-3 bg-black hover:bg-green-700 transition w-full max-w-md mx-auto">
                                        <Link to="/blogpage5">
                                            <div className="flex justify-between items-center">
                                                <h2 className="text-xl font-medium text-white px-3 py-1 rounded">
                                                    Engineered Type
                                                </h2>
                                                <span className="bg-green-700 group-hover:bg-black text-white rounded-full w-8 h-8 flex items-center justify-center text-sm transition">5
                                                </span>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="group px-3 py-2 xl:py-3 bg-black hover:bg-green-700 transition w-full max-w-md mx-auto">
                                        <Link to="/blogpage6">
                                            <div className="flex justify-between items-center">
                                                <h2 className="text-xl font-medium text-white px-3 py-1 rounded">
                                                    Smoke Detector
                                                </h2>
                                                <span className="bg-green-700 group-hover:bg-black text-white rounded-full w-8 h-8 flex items-center justify-center text-sm transition">6
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div> */}

                            {/* Categories Box */}
                            <div className="bg-white px-4 py-2 shadow-md w-full border-b-4 border-green-600">
                                <h1 className="text-md md:text-lg font-semibold mb-2 text-black">Categories</h1>

                                <div className="px-12">
                                    <ul className="space-y-1.5 list-disc pl-6 text-black">

                                        <li>
                                            <Link to="/blogpage" className="text-sm md:text-base font-medium text-black hover:text-green-700">
                                                Common Devices
                                            </Link>
                                        </li>

                                        <li>
                                            <Link to="/blogpage2" className="text-sm md:text-base font-medium text-black hover:text-green-700">
                                                Fire Alarm System, N3060
                                            </Link>
                                        </li>

                                        <li>
                                            <Link to="/blogpage3" className="text-sm md:text-base font-medium text-black hover:text-green-700">
                                                Fire Alarm System, N765
                                            </Link>
                                        </li>

                                        <li>
                                            <Link to="/blogpage5" className="text-sm md:text-base font-medium text-black hover:text-green-700">
                                                Engineered Type
                                            </Link>
                                        </li>

                                        <li>
                                            <Link to="/blogpage6" className="text-sm md:text-base font-medium text-black hover:text-green-700">
                                                Aspirating Smoke Detector
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                {/* <div className="space-y-1.5">
                                    <div className="group py-1 bg-white w-full max-w-md mx-auto">
                                        <Link to="/blogpage">
                                            <div className="px-12 py-1 items-center list-disc">
                                                <h2 className="text-sm md:text-base font-medium text-black">Common Devices</h2>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="group py-1 bg-white w-full max-w-md mx-auto">
                                        <Link to="/blogpage2">
                                            <div className="px-12 py-1 items-center">
                                                <h2 className="text-sm md:text-base font-medium text-black">Fire Alarm System, N3060</h2>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="group py-1 bg-white w-full max-w-md mx-auto">
                                        <Link to="/blogpage3">
                                            <div className="px-12 py-1 items-center">
                                                <h2 className="text-sm md:text-base font-medium text-black">Fire Alarm System, N765</h2>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="group py-1 bg-white w-full max-w-md mx-auto">
                                        <Link to="/blogpage5">
                                            <div className="px-12 py-1 items-center">
                                                <h2 className="text-sm md:text-base font-medium text-black">Engineered Type</h2>
                                            </div>
                                        </Link>
                                    </div>

                                    <div className="group py-1 bg-white w-full max-w-md mx-auto">
                                        <Link to="/blogpage6">
                                            <div className="px-12 py-1 items-center">
                                                <h2 className="text-sm md:text-base font-medium text-black">Aspirating Smoke Detector</h2>
                                            </div>
                                        </Link>
                                    </div>
                                </div> */}
                            </div>

                            {/* Recent Posts Box */}
                            <div className="bg-white shadow-md px-4 py-2 border-b-4 border-green-700 mt-2">
                                <h2 className="text-md md:text-lg font-semibold text-black mb-2">Recent Posts</h2>

                                <Link to="/blogpage">
                                    <div className="flex gap-3 mb-2">
                                        <img src={common} alt="Common Devices" className="w-12 h-12 object-contain" />
                                        <p className="text-sm md:text-base font-medium leading-tight">
                                            Common Devices for Addressable Systems
                                        </p>
                                    </div>
                                </Link>

                                <Link to="/blogpage2">
                                    <div className="flex gap-3 mb-2">
                                        <img src={fireal} alt="N3060" className="w-12 h-12 object-contain" />
                                        <p className="text-sm md:text-base font-medium leading-tight">
                                            Fire Alarm System, N3060
                                        </p>
                                    </div>
                                </Link>

                                <Link to="/blogpage5">
                                    <div className="flex gap-3">
                                        <img src={nitrogen} alt="Nitrogen Gas" className="w-12 h-12 object-contain" />
                                        <p className="text-sm md:text-base font-medium leading-tight">
                                            Nitrogen Gas Suppression System
                                        </p>
                                    </div>
                                </Link>
                            </div>

                        </div>

                        {/* Tags  */}
                        {/* <div className="bg-white px-4 xl:px-10 py-4 xl:py-8 shadow-md w-full border-b-4 border-green-600">
                            <h1 className="text-xl xl:text-2xl font-semibold mb-4 text-gray-800">Post Tags</h1>

                            <div className="flex flex-wrap gap-3 mt-6">
                                {tags.map((tag, i) => (
                                    <span key={i} className="text-sm px-3 py-1 bg-white border text-green-600 hover:text-white hover:bg-green-700 border-gray-400 hover:border-green-700">
                                        {tag}
                                    </span>
                                ))}
                            </div>
                        </div> */}
                    </div>
                </div>
            </div >

            <div><Footer /></div>

        </>
    )
}

export default BlogPage3